// Contacts GraphQL mutations

import { gql } from "@apollo/client"

export const CREATE_CONTACT = gql`
  mutation CreateContact($input: CreateContactInput!) {
    createContact(input: $input) {
      id
      contactID
      firstName
      lastName
      displayName
      email
      companyName
      title
      gender
      phone1
      phone2
      phone3
      active
      businessAccount
    }
  }
`

export const UPDATE_CONTACT = gql`
  mutation UpdateContact($input: UpdateContactInput!) {
    updateContact(input: $input) {
      id
      contactID
      firstName
      lastName
      title
      displayName
      email
      companyName
      gender
      phone1
      phone2
      phone3
      active
      businessAccount
    }
  }
`
